import React, { Component, createRef } from 'react';
import PersonalInfo from '../Sections/PersonalInfo';
import ContactInfo from '../Sections/ContactInfo';
import EmploymentInfo from '../Sections/EmploymentInfo';
import {
  SignificantOtherPersonalInfo,
  SignificantOtherContactInfo,
  SignificantOtherEmploymentInfo,
} from '../Sections/SignificantOther';
import Navigator from '../UI/Navigator';

class PersonalInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      significantOtherSectionVisible: false,
    };
    this.significantOtherSectionsRef = createRef();
    this.handleMaritalStatusChange = this.handleMaritalStatusChange.bind(this);
  }

  handleMaritalStatusChange(name, value) {
    this.setState({
      significantOtherSectionVisible:
        value === 'married' || value === 'significantOther',
    });
  }

  render() {
    const { significantOtherSectionVisible } = this.state;
    // emulate the old callsToProps behavior this component used to use

    return (
      <Navigator>
        <PersonalInfo
          significantOtherSectionsRef={this.significantOtherSectionsRef}
          handleMaritalStatusChange={this.handleMaritalStatusChange}
        />
        <ContactInfo />
        <EmploymentInfo isLastSection={!significantOtherSectionVisible} />
        {/* TODO: Refactor.  This is necessary for screen.jsx as it is currently
          written.  It needs all of the children to be present in props.children */}
        {significantOtherSectionVisible && (
          <SignificantOtherPersonalInfo />
        )}
        {significantOtherSectionVisible && <SignificantOtherContactInfo />}
        {significantOtherSectionVisible && <SignificantOtherEmploymentInfo />}
      </Navigator>
    );
  }
}

PersonalInformation.propTypes = {};

export default PersonalInformation;
